import revivoFrame from "../../../assets/images/svgs/Frame.svg";
import revivoLogo from "../../../assets/logo/logo.svg";
import karunaFrame from "../../../assets/images/svgs/Frame.karuna.svg";
import karunaLogo from "../../../assets/logo/logo.karuna.svg";
import { useDispatch } from "react-redux";
import { updateActiveMenu } from "../../../reducer/appReducer";
import { useNavigate } from "react-router-dom";
import { activeBrand, productName } from "../../../theme";
import useSidebarCollapsed from "../../../hooks/useSidebarCollapsed";

// Per-brand logo assets — add a brand here once its Frame/logo files exist.
const BRAND_LOGOS = {
  revivo: { frame: revivoFrame, logo: revivoLogo },
  karuna: { frame: karunaFrame, logo: karunaLogo },
};
const { frame: BrandLogo, logo: Logo } =
  BRAND_LOGOS[activeBrand.name] || BRAND_LOGOS.revivo;

const SideBarImage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const collapsed = useSidebarCollapsed();

  const home = () => {
    dispatch(
      updateActiveMenu({
        activeMenu: "home",
        pos: false,
      })
    );

    navigate("/dashboard");
  };

  return (
    <div className="pt-[55px] pr-[20px] pl-[25px] cursor-pointer">
      <img
        onClick={() => home()}
        src={collapsed ? Logo : BrandLogo}
        className="h-[30px] md:h-[40px] lg:h-[50px]"
        alt={`${productName} Brand`}
      />
    </div>
  );
};
export default SideBarImage;
